"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.issuesWatchers = exports.issuesReducers = void 0;
const xuder_1 = require("@sonar-software/xuder");
const redux_1 = require("redux");
const archived_1 = require("./archived/index.js");
const _id_1 = require("./_id/index.js");
const snoozed_1 = require("./snoozed/index.js");
const visible_1 = require("./visible/index.js");
exports.issuesReducers = (0, redux_1.combineReducers)({
    archived: archived_1.issuesArchivedReducers,
    byId: _id_1.issuesByIdReducers,
    snoozed: snoozed_1.issuesSnoozedReducers,
    visible: visible_1.issuesVisibleReducers
});
exports.issuesWatchers = (0, xuder_1.combineAllWatchers)([
    archived_1.issuesArchivedWatchers,
    _id_1.issuesByIdWatchers,
    snoozed_1.issuesSnoozedWatchers,
    visible_1.issuesVisibleWatchers
]);
//# sourceMappingURL=index.js.map